import _ from 'lodash'
import bgList from './bgList'

const backgrounds = {
  data: () => ({
    pixiBackgrounds: bgList,
    bgName: 'home'
  }),
  computed: {
    background: {
      get () {
        return this.$_nearestBackground(this.bgName)
      }
    }
  },
  methods: {
    $_nearestBackground (bgName) {
      const backgroundWidths = _.keys(this.pixiBackgrounds[bgName])
      const differences = _.map(backgroundWidths, width => Math.abs(window.innerWidth - width))
      return this.pixiBackgrounds[bgName][backgroundWidths[_.indexOf(differences, _.head(_.sortBy(differences)))]]
    }
  }
}

export default backgrounds
